export function randomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

interface ObjectWithId {
  _id: string;
}

export function updateOrAppendItem<T extends ObjectWithId>(list: T[], item: T): T[] {
  if (list.find((i) => i._id === item._id)) {
    // Update in list
    return list.map((i) => (i._id === item._id ? item : i));
  }
  return [...list, item]; // Append
}
